var map = {
	"./Accordion.svg": 533,
	"./Breadcrumb.svg": 534,
	"./Button.svg": 535,
	"./Checkbox.svg": 536,
	"./Code snippet.svg": 537,
	"./Content switcher.svg": 538,
	"./Data table.svg": 539,
	"./Date picker.svg": 540,
	"./Dropdown.svg": 541,
	"./File uploader.svg": 542,
	"./Form.svg": 543,
	"./Inline loading.svg": 544,
	"./Link.svg": 545,
	"./List.svg": 546,
	"./Loading.svg": 547,
	"./Modal.svg": 548,
	"./Multiselect.svg": 549,
	"./NoImage.svg": 329,
	"./Notification.svg": 550,
	"./Number input.svg": 551,
	"./Overflow menu.svg": 552,
	"./Pagination.svg": 553,
	"./Progress indicator.svg": 554,
	"./Radio button.svg": 555,
	"./Search.svg": 556,
	"./Select.svg": 557,
	"./Slider.svg": 558,
	"./Structured list.svg": 559,
	"./Tabs.svg": 560,
	"./Tag.svg": 561,
	"./Text input.svg": 562,
	"./Tile.svg": 563,
	"./Toggle.svg": 564,
	"./Tooltip.svg": 565,
	"./UI shell.svg": 566
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 532;